import React, { useEffect, useMemo, useState } from "react";
import "./home.styles.scss";
import {
  Checkbox,
  Select,
  message,
  Modal,
  Card,
  Statistic,
  Flex,
  Row,
  Col,
  Space,
  Typography,
  Button,
} from "antd";

import {
  CaretUpOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import { connect, useDispatch } from "react-redux";

import { createStructuredSelector } from "reselect";

import {
  selectCrops,
  selectSelectedCrop,
  selectBypassBD,
  selectBranches,
  selectVarieties,
} from "../../redux/common/common.selectors";
import {
  getBranchesService,
  getSeasonService,
  getTraderSummaryService,
  getVarietiesService,
  getVarietyProcurementService,
} from "../../services/common-services";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";

import { setBypassBD, setCurrentPage } from "../../redux/common/common.actions";
import { Dispatch } from "redux";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import dayjs from "dayjs";
import { getDashboardDetails } from "../../services/auction-services";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  ResponsiveContainer,
  Label,
} from "recharts";
const { Text } = Typography;
const { Option } = Select;
const { confirm } = Modal;

const COLORS = ["#1890FF", "#48AC33"];
const BARCOLORS = [
  "#6BCF56",
  "#4DA9FF",
  "#FFD966",
  "#F47A8E",
  "#48AC33",
  "#1890FF",
  "#F5BF15",
  "#F04864",
  "#3C922B",
  "#0F6ED1",
  "#D4A313",
  "#C93B54",
  "#2F7A21",
  "#0A55A8",
  "#B88B0F",
  "#A92F45",
];
const Home: React.FC = (props: any) => {
  const {
    user,
    crops,
    // branchList,
    bypassBD,
    setBypassBD,
    authData,
    // setSelectedCrop,
  } = props;
  const dispatch = useDispatch();
  const [dashboardData, setDashboardData] = useState<any>([]);
  const [seasonList, setSeasons] = useState<any>([]);
  const [branchList, setBranches] = useState<any>([]);
  const [varietyRecords, setVarietyRecord] = useState<any>([]);
  const [varietyList, setVarietyList] = useState<any>([]);
  const [summaryRecords, setSummaryRecord] = useState<any>({
    broker: [],
    trader: [],
    procurement_total: "",
  });
  const [selectedCrop, setSelectedCrop] = useState<any>();
  const [selectedBranch, setSelectedBranch] = useState<any>();
  const [selectedSeason, setSelectedSeason] = useState<any>();
  const [procurementVariety, setSelectedProcurementVariety] = useState<any>();
  const [selectedVariety, setSelectedVariety] = useState<any>(0);
  const [procurementMetrics, setProcurementMetrics] = useState<any>("mt");
  const [selectedDates, setSelectedDates] = useState<any>([]);
  useMemo(async () => {
    try {
      const branchesResponse = await getBranchesService();
      let userBasedBranches = branchesResponse.data.data.filter((x: any) =>
        user.user_territories.includes(x.territory_id)
      );
      const branchData = userBasedBranches.map((item: any) => {
        return {
          id: item.territory_id,
          name: item.territory_name,
        };
      });
      const defaultBranch = branchData.filter(
        (items) =>
          user.active_territories.hasOwnProperty(
            selectedCrop ?? crops[0]?.id
          ) &&
          user.active_territories[selectedCrop ?? crops[0]?.id].includes(
            items.id
          )
      );
      setBranches(defaultBranch);
      setSelectedBranch(defaultBranch[0]?.id);
      !selectedCrop && setSelectedCrop(crops[0]?.id);
    } catch (error) {
      console.log(error);
    }
  }, [authData.access_token, selectedCrop, crops]);

  useMemo(async () => {
    try {
      const seasonResponse: any = await getSeasonService();
      if (seasonResponse.data.status) {
        let defaultData;
        const tempSeasonList = seasonResponse.data.data.map((item: any) => {
          if (item.default_flag == 1) {
            defaultData = item.id;
            setSelectedDates([
              dayjs(item.start_date).format("YYYY-MM-DD"),
              dayjs(item.end_date).format("YYYY-MM-DD"),
            ]);
          }
          return {
            id: item.id,
            name: item.season,
            startDate: item.start_date,
            endDate: item.end_date,
          };
        });
        setSeasons(tempSeasonList);
        setSelectedSeason(defaultData);
      }
    } catch (error) {
      console.log(error);
    }
  }, [authData.access_token]);

  useMemo(async () => {
    try {
      if (
        (selectedCrop || crops[0]?.id) &&
        (selectedBranch || branchList[0]?.id)
      ) {
        const cropBranchBody = {
          crop_id: selectedCrop ?? crops[0]?.id,
          branch_id: selectedBranch ?? branchList[0]?.id,
        };
        const varietiesResponse = await getVarietiesService(cropBranchBody);
        const varietyData = varietiesResponse.data.data.map((item: any) => {
          return {
            id: item.variety_id,
            name: item.variety_name,
          };
        });
        setSelectedProcurementVariety("");
        setSelectedVariety("");
        setVarietyList(varietyData);
      }
    } catch (error) {
      console.log(error);
    }
  }, [authData.access_token, crops, branchList, selectedCrop, selectedBranch]);

  useMemo(async () => {
    try {
      const params = {
        branch_id: selectedBranch ? [selectedBranch] : [branchList[0]?.id],
        crop_id: selectedCrop ? [selectedCrop] : [crops[0]?.id],
        variety_id: procurementVariety && [procurementVariety],
        metric: procurementMetrics,
        season_id: selectedSeason,
      };
      const summaryResponse: any = await getTraderSummaryService(params);
      if (summaryResponse.data.status) {
        const tempData = summaryResponse.data.data;
        setSummaryRecord({
          trader: [
            { name: "Old", value: parseFloat(tempData.trader.old) },
            { name: "New", value: parseFloat(tempData.trader.new) },
          ],
          traderTotal: tempData.trader.total,
          broker: [
            { name: "Old", value: parseFloat(tempData.broker.old) },
            { name: "New", value: parseFloat(tempData.broker.new) },
          ],
          brokerTotal: tempData.broker.total,
          totalProcurment: tempData.procurement_total,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [
    authData,
    selectedBranch,
    selectedCrop,
    procurementMetrics,
    procurementVariety,
    crops,
    branchList,
    selectedSeason,
  ]);
  useMemo(async () => {
    try {
      const params = {
        branch_id: selectedBranch ? [selectedBranch] : [branchList[0]?.id],
        crop_id: selectedCrop ? [selectedCrop] : [crops[0]?.id],
        // variety_id: selectedVariety && [selectedVariety],
      };
      const procurementResponse: any = await getVarietyProcurementService(
        params
      );
      if (
        procurementResponse.data.status &&
        procurementResponse.data.data.data.length > 0
      ) {
        setVarietyRecord(procurementResponse.data.data.data);
      } else
        setVarietyRecord([
          {
            date: "0",
          },
        ]);
    } catch (error) {
      console.log(error);
    }
  }, [
    authData.access_token,
    selectedVariety,
    selectedBranch,
    selectedCrop,
    crops,
    branchList,
  ]);
  useMemo(async () => {
    try {
      if (
        (selectedCrop || crops[0]?.id) &&
        (selectedBranch || branchList[0]?.id)
      ) {
        const params = {
          select_season: selectedSeason && [selectedSeason],
          select_crop: selectedCrop ? [selectedCrop] : [crops[0]?.id],
          select_branch: selectedBranch
            ? [selectedBranch]
            : [branchList[0]?.id],
        };
        const dashboardDetails = await getDashboardDetails(params);
        if (dashboardDetails.data.success == true) {
          setDashboardData(dashboardDetails.data.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [
    authData.access_token,
    selectedCrop,
    selectedBranch,
    selectedSeason,
    selectedDates,
  ]);
  const onCheckChanged = (value: boolean) => {
    if (value) {
      showPromiseConfirm(value);
    } else {
      setBypassBD(value);
    }
  };

  const showPromiseConfirm = (value: boolean) => {
    confirm({
      title: "Bypass Copy Auction ?",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to bypass ?",
      onOk() {
        setBypassBD(value);
        dispatch(setCurrentPage(2));
      },
      onCancel() {},
    });
  };

  const onChangeCrop = (id: number) => {
    setSelectedCrop(id);
  };
  const onChangeSeason = (id) => {
    setSelectedSeason(id);
    const tempRange = seasonList.filter((item) => item.id == id);
    if (tempRange.length > 0)
      setSelectedDates([
        dayjs(tempRange[0].startDate).format("YYYY-MM-DD"),
        dayjs(tempRange[0].endDate).format("YYYY-MM-DD"),
      ]);
  };
  const onChangeRange = (value, data) => {
    setSelectedDates(data);
  };

  return (
    <div className="home">
      <Flex gap={10} style={{ paddingBottom: 10 }} wrap>
        <CustomFilter
          type="single-select"
          value={selectedCrop}
          options={crops}
          onChange={onChangeCrop}
          placeholder="Select Crop"
          head="Crop"
          className="status-filter"
          returnId
        />
        <CustomFilter
          type="single-select"
          value={selectedSeason}
          options={seasonList}
          onChange={onChangeSeason}
          placeholder="Select Season"
          head="Season"
          className="status-filter"
          returnId
        />
        <CustomFilter
          type="single-select"
          value={selectedBranch}
          options={branchList}
          onChange={setSelectedBranch}
          placeholder="Select Branch"
          head="Branch"
          className="status-filter"
          returnId
        />
        <CustomFilter
          type="range-picker"
          head="Date Range"
          startDate={selectedDates.length && dayjs(selectedDates[0])}
          endDate={selectedDates.length && dayjs(selectedDates[1])}
          disabledDate={seasonList.filter((item) => item.id == selectedSeason)}
          onChange={onChangeRange}
        />
      </Flex>
      <Flex gap={10} wrap>
        <Card
          style={{
            textAlign: "start",
            border: "1px solid #48AC33",
            borderRadius: 0,
            width: "40vh",
          }}
        >
          <Space direction="vertical" align="start">
            <Space
              style={{
                borderBottom: "1px solid #0000000F",
                justifyContent: "space-between",
                width: "33vh",
              }}
              align="start"
            >
              <Statistic
                title="Total Procurement"
                value={dashboardData.total_procurement}
                valueStyle={{ fontWeight: 500 }}
                style={{ lineHeight: 1.2, marginBottom: 10 }}
              />
              {/* <Button type="link" style={{ top: -10 }}>
                <InfoCircleOutlined style={{ color: "#000000b0" }} />
              </Button> */}
            </Space>
            <Text>Day Procurement {dashboardData.day_procurement}</Text>
          </Space>
        </Card>
        <Card
          style={{
            textAlign: "start",
            border: "1px solid #48AC33",
            borderRadius: 0,
            width: "40vh",
          }}
        >
          <Space direction="vertical" align="start">
            <Space
              style={{
                borderBottom: "1px solid #0000000F",
                justifyContent: "space-between",
                width: "33vh",
              }}
              align="start"
            >
              <Statistic
                title="Total Auctions"
                value={dashboardData.total_auction}
                valueStyle={{ fontWeight: 500 }}
                style={{ lineHeight: 1.2, marginBottom: 10 }}
              />
              {/* <Button type="link" style={{ top: -10 }}>
                <InfoCircleOutlined style={{ color: "#000000b0" }} />
              </Button> */}
            </Space>
            <Text>Day Auctions {dashboardData.day_auction}</Text>
          </Space>
        </Card>
        <Card
          style={{
            textAlign: "start",
            border: "1px solid #48AC33",
            borderRadius: 0,
            width: "40vh",
          }}
        >
          <Space direction="vertical" align="start">
            <Space
              style={{
                borderBottom: "1px solid #0000000F",
                justifyContent: "space-between",
                width: "33vh",
              }}
            >
              <Statistic
                title="New Vendor Procurement"
                value={dashboardData.new_vendor_procurement}
                valueStyle={{ fontWeight: 500 }}
                style={{ lineHeight: 1.2, marginBottom: 10 }}
              />
              {/* <Button type="link" style={{ top: -20 }}>
                <InfoCircleOutlined style={{ color: "#000000b0" }} />
              </Button> */}
            </Space>
            <Text>
              Day Procurement {dashboardData.day_new_vendor_procurement}
            </Text>
          </Space>
        </Card>
        <Card
          style={{
            textAlign: "start",
            border: "1px solid #48AC33",
            borderRadius: 0,
            width: "40vh",
          }}
        >
          <Space direction="vertical" align="start">
            <Space
              style={{
                borderBottom: "1px solid #0000000F",
                justifyContent: "space-between",
                width: "33vh",
              }}
              align="start"
            >
              <Statistic
                title="Total Traders/Customers"
                value={dashboardData.total_customers}
                valueStyle={{ fontWeight: 500 }}
                style={{ lineHeight: 1.2, marginBottom: 10 }}
              />
              {/* <Button type="link" style={{ top: -10 }}>
                <InfoCircleOutlined style={{ color: "#000000b0" }} />
              </Button> */}
            </Space>
            <Text>
              Active Customers {dashboardData.active_customers}{" "}
              <CaretUpOutlined style={{ color: "#52C41A" }} />
            </Text>
          </Space>
        </Card>
      </Flex>
      <Flex align="center" gap={10} style={{ paddingTop: 10 }} wrap>
        <Card
          size="small"
          title={`Procurement: ${summaryRecords.totalProcurment}`}
          extra={
            <Space>
              <CustomFilter
                type="single-select"
                value={procurementVariety}
                options={varietyList}
                onChange={setSelectedProcurementVariety}
                placeholder="Select Variety"
                head="Variety"
                className="status-filter"
                returnId
              />
              <CustomFilter
                type="single-select"
                value={procurementMetrics}
                options={[
                  { id: "mt", name: "Metric Tons" },
                  { id: "quintal", name: "Quintals" },
                  { id: "kg", name: "KG" },
                ]}
                onChange={setProcurementMetrics}
                placeholder="Metrics"
                head="Metrics"
                className="status-filter"
                returnId
              />
            </Space>
          }
          className="card-piechart"
        >
          <Flex justify="space-evenly" gap={30}>
            <Typography.Text strong>Direct Trader Procurement</Typography.Text>
            <Typography.Text strong>Broker Aided</Typography.Text>
          </Flex>
          <Space size={0}>
            <PieChart
              width={
                window.innerHeight < 820 && window.innerWidth < 480 ? 160 : 180
              }
              height={230}
            >
              <Pie
                data={summaryRecords.trader}
                cx="50%"
                cy="50%"
                // label
                innerRadius="50%"
                outerRadius="80%"
                dataKey="value"
              >
                {summaryRecords.trader.length > 0 &&
                  parseFloat(summaryRecords.traderTotal) > 0 &&
                  summaryRecords.trader?.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
              </Pie>
              <text
                x="50%"
                y="40%"
                textAnchor="middle"
                dominantBaseline="middle"
              >
                {parseFloat(summaryRecords.traderTotal) > 0 ? (
                  <>
                    <tspan x={"50%"} dy="0">
                      {summaryRecords.traderTotal}
                    </tspan>
                    <tspan x={"50%"} dy="20" fill="#8C97A7">
                      Total
                    </tspan>
                  </>
                ) : (
                  <>
                    <tspan x={"50%"} dy="0">
                      No Trader
                    </tspan>
                    <tspan x={"50%"} dy="20">
                      Procurement available
                    </tspan>
                  </>
                )}
              </text>
              <Legend
                iconType={"circle"}
                iconSize={5}
                layout="vertical"
                formatter={(value, entry: any) => {
                  const dataValue = entry.payload.value ?? "";
                  return (
                    <span style={{ color: "black" }}>
                      {value}{" "}
                      <span style={{ fontSize: 14, fontWeight: 700 }}>
                        {dataValue}
                      </span>{" "}
                      {procurementMetrics.toUpperCase()}
                    </span>
                  );
                }}
              />
            </PieChart>
            <PieChart
              width={
                window.innerHeight < 820 && window.innerWidth < 480 ? 160 : 180
              }
              height={230}
            >
              <Pie
                data={summaryRecords.broker}
                cx="50%"
                cy="50%"
                // label
                innerRadius="50%"
                outerRadius="80%"
                dataKey="value"
              >
                {summaryRecords.broker.length > 0 &&
                  summaryRecords.broker.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
              </Pie>
              <text
                x="50%"
                y="40%"
                textAnchor="middle"
                dominantBaseline="middle"
              >
                {parseFloat(summaryRecords.brokerTotal) > 0 ? (
                  <>
                    {summaryRecords.brokerTotal}
                    <tspan x={"50%"} dy="20" fill="#8C97A7">
                      Total
                    </tspan>
                  </>
                ) : (
                  <>
                    <tspan x={"50%"} dy="0">
                      No Broker
                    </tspan>
                    <tspan x={"50%"} dy="20">
                      Procurement Available
                    </tspan>
                  </>
                )}
              </text>
              <Legend
                iconType={"circle"}
                iconSize={5}
                layout="vertical"
                formatter={(value, entry: any) => {
                  const dataValue = entry.payload.value ?? "";
                  return (
                    <span style={{ color: "black" }}>
                      {value}{" "}
                      <span style={{ fontSize: 14, fontWeight: 700 }}>
                        {dataValue}
                      </span>{" "}
                      {procurementMetrics.toUpperCase()}
                    </span>
                  );
                }}
              />
            </PieChart>
          </Space>
        </Card>
        <Card
          title={
            <>
              Variety Level Procurement{" "}
              <Text type="secondary">(last 15 days procurement)</Text>
            </>
          }
          size="small"
          extra={
            <CustomFilter
              type="single-select"
              value={selectedVariety}
              options={[{ id: 0, name: "All" }, ...varietyList]}
              onChange={setSelectedVariety}
              defaultValue={0}
              placeholder="Select Variety"
              head="Variety"
              className="status-filter"
              returnId
            />
          }
          className="card-barchart"
        >
          <Flex justify="space-between">
            <span
              style={{
                fontWeight: 400,
              }}
            >
              In {crops?.find((item) => item.id == selectedCrop)?.unit}
            </span>
            <span
              style={{
                paddingRight: 100,
                fontWeight: 400,
              }}
            >
              Varieties
            </span>
          </Flex>
          <Space>
            <BarChart
              data={varietyRecords}
              width={
                window.innerWidth < 480
                  ? window.innerHeight < 820
                    ? 310
                    : 340
                  : window.innerWidth < 768
                  ? 500
                  : 580
              }
              height={230}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="date" height={20} axisLine={false} />
              <YAxis width={35} axisLine={false} />
              <Tooltip />
              <Legend
                layout="vertical"
                verticalAlign="top"
                align="right"
                content={(props) => {
                  // const { payload } = props;
                  // const barKeys = Array.from(
                  //   new Set(
                  //     varietyRecords.flatMap((item) =>
                  //       Object.keys(item).filter((key) => key !== "date")
                  //     )
                  //   )
                  // );
                  const barKeys = varietyList.map((v) => v.name);
                  const totals: any = barKeys.reduce((acc: any, key: any) => {
                    acc[key] = varietyRecords.reduce(
                      (sum, d) => sum + (d[key] || 0),
                      0
                    );
                    return acc;
                  }, {});
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        overflow: "scroll",
                        height: 220,
                      }}
                    >
                      {barKeys?.map((entry: any, index) => (
                        <div
                          key={entry}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <div
                            style={{
                              width: 15,
                              height: 15,
                              borderRadius: "50%",
                              backgroundColor: BARCOLORS[index],
                              color: "#fff",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: 12,
                              fontWeight: "bold",
                            }}
                          >
                            {index + 1}
                          </div>
                          <span style={{ fontSize: 14 }}>
                            {entry} {totals[entry] ?? 0}{" "}
                            {
                              crops?.find((item) => item.id == selectedCrop)
                                ?.unit
                            }
                          </span>
                        </div>
                      ))}
                    </div>
                  );
                }}
              />
              {varietyList.map((item, index) => {
                if (selectedVariety != 0 && selectedVariety !== item.id) {
                  return null;
                }
                return (
                  <Bar
                    key={item.name}
                    dataKey={item.name}
                    stackId="a"
                    fill={BARCOLORS[index]}
                    maxBarSize={20}
                  />
                );
              })}
            </BarChart>
          </Space>
        </Card>
      </Flex>
      {/* <div className="contents">
        <div className="preference">
          <div>Select Crop</div>
          <div className="select-container">
            <Select
              value={selectedCropId}
              onSelect={(id: number) => onChangeCrop(id)}
            >
              {crops.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </div>
          <Checkbox
            checked={bypassBD}
            onChange={(e) => {
              onCheckChanged(e.target.checked);
            }}
            disabled={!canUserAccess(user, FeatureCodes.AUCTION_MAKER)}
          >
            Bypass Copy Auction
          </Checkbox>
        </div>
      </div> */}
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    // setSelectedCrop: (cropId: number) => dispatch(setSelectedCrop(cropId)),
    setBypassBD: (status: boolean) => dispatch(setBypassBD(status)),
  };
};

const mapStateToProps = createStructuredSelector({
  user: selectUserData,
  crops: selectCrops,
  // branchList: selectBranches,
  selectedCropId: selectSelectedCrop,
  bypassBD: selectBypassBD,
  authData: selectAuthData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
